import { roundCents } from '@/utils/money'
import type { CalculatorContext } from '@/types/calculator'
import type { VatInputs, VatResult } from './types'

export function calculateVat(inputs: VatInputs, _context: CalculatorContext): VatResult {
  const rate = inputs.rate
  const amount = inputs.amount

  let vatAmount = 0
  let netAmount = amount
  let grossAmount = amount

  if (inputs.direction === 'add') {
    vatAmount = amount * rate
    grossAmount = amount + vatAmount
  } else {
    netAmount = amount / (1 + rate)
    vatAmount = amount - netAmount
    grossAmount = amount
  }

  return {
    inputAmount: roundCents(amount),
    vatRate: rate,
    vatAmount: roundCents(vatAmount),
    netAmount: roundCents(netAmount),
    grossAmount: roundCents(grossAmount),
  }
}
